import React from "react";

// The header and footer here are FIXED chrome -- always the same structure/
// styling for a given page's branding data, never a different look per
// page -- so navigating between pages within a portal flow (home -> form ->
// thank you) never shows inconsistent chrome. Purely data-driven: logo/
// title/color all come from the page row (header_logo_url/header_title/
// header_color) -- nothing about any specific portal's branding is
// hardcoded here. Consistency across pages is a matter of setting the same
// header_* values on every page in a flow, not something this component
// enforces on its own.
const PortalShell = ({ headerLogoUrl, headerTitle, headerColor, pageTitle, children }) => {
  const color = headerColor || "#111827";

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header style={{ backgroundColor: color }} className="text-white">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3">
          {headerLogoUrl && <img src={headerLogoUrl} alt="" className="h-9 w-9 rounded-full" />}
          {headerTitle && <span className="text-lg font-semibold">{headerTitle}</span>}
        </div>
        {pageTitle && (
          <div className="max-w-5xl mx-auto px-6 pb-4">
            <h1 className="text-xl font-semibold">{pageTitle}</h1>
          </div>
        )}
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-6 py-8">{children}</main>

      <footer className="border-t border-gray-200 bg-white">
        <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            {headerLogoUrl && <img src={headerLogoUrl} alt="" className="h-6 w-6 rounded-full opacity-70" />}
            {headerTitle && <span className="text-sm text-gray-500">{headerTitle}</span>}
          </div>
          {headerTitle && (
            <p className="text-xs text-gray-400">
              © {new Date().getFullYear()} {headerTitle} — all rights reserved
            </p>
          )}
        </div>
      </footer>
    </div>
  );
};

export default PortalShell;
